import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { Element } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"
import "twin.macro"
import Aboutme from "../components/Sections/AboutmeSection"
import Portfolio from "../components/Sections/PortfolioSection"
import Experience from "../components/Sections/ExperienceSection"
import Reference from "../components/Sections/ReferencesSection"
import Blog from "../components/Sections/BlogSection"
import Contact from "../components/Sections/ContactSection"
import Footer from "../components/Sections/FooterSection"
import Navber from "../components/Sections/NavberSection"
const BlogIndex: React.FC = () => {
  return (
    <Layout>
      <Seo title="NAME" />
      <div tw="flex pt-6 justify-center">
        <StaticImage
          src="../images/logo.svg"
          height={40}
          width={40}
          alt="A dinosaur"
        />
        <p tw=" text-2xl font-bold">DESIGNER </p>
      </div>

      <div tw=" grid md:(grid-cols-8 gap-10 p-10) max-w-7xl mx-auto">
        {/* left side */}
        <div tw=" md:col-span-2   w-full ">
          <div tw=" bg-green-200  p-5 px-10 sm:shadow-2xl w-full sticky top-4">
            <div tw="flex flex-col justify-center items-center">
              <StaticImage
                src="../images/ref.png"
                alt="A dinosaur"
                style={{
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />

              <h2 tw="  font-semibold text-xl">"NAME"</h2>
              <h4 tw="text-gray-500 ">"ROLE"</h4>
            </div>
          </div>
        </div>

        {/* MIDDLE side */}
        <div tw="max-w-3xl md:col-span-5  w-full">
          <Element name="about" className="element">
            <Aboutme />
          </Element>
          <Element name="portfolio" className="element">
            <Portfolio />
          </Element>
          <Element name="experience" className="element">
            <Experience />
          </Element>
          <Element name="reff" className="element">
            <Reference />
          </Element>
          <Element name="blog" className="element">
            <Blog />
          </Element>

          <Element name="contact" className="element">
            <Contact />
          </Element>

          <Footer />
        </div>

        {/* RIght side */}
        <div tw="row-start-1  md:( row-start-auto col-span-1 ) ">
          <Navber />
        </div>
      </div>
    </Layout>
  )
}
export default BlogIndex
